const tables = [
  {
    name: "Journal Date",
  },
  {
    name: "Time",
  },
  {
    name: "Account Name",
  },
  {
    name: "Account Code",
  },

  {
    name: "Description",
  },

  {
    name: "Debit",
  },
  {
    name: "Credit",
  },
  {
    name: "Status",
  },
  {
    name: "Attachments",
  },
  {
    name: "Reference",
  },
];

export default tables;
